exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Table .Table-Footer{display:-ms-flexbox;display:flex}.Table .Table-Footer .erg-components-Pagination{-ms-flex:1;flex:1}", "", {"version":3,"sources":["/./node_modules/@ergeon/erg-components-react/lib/table/node_modules/@ergeon/erg-components-react/lib/table/Table.scss"],"names":[],"mappings":"AAAA,qBAEI,oBACA,YAAa,CAHjB,gDAKM,WACI,MAAO,CACZ","file":"Table.scss","sourcesContent":[".Table{\n  .Table-Footer {\n    display: -ms-flexbox;\n    display: flex;\n    .erg-components-Pagination {\n      -ms-flex: 1;\n          flex: 1;\n    }\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?sourceMap!./~/sass-loader?sourceMap&includePaths[]=/home/circleci/project/bower_components&includePaths[]=/home/circleci/project/node_modules!./~/postcss-loader!./~/@ergeon/erg-components-react/lib/table/Table.scss
 ** module id = 1157
 ** module chunks = 0
 **/